"use client";

import { c as _c } from "react/compiler-runtime";
import { Carousel, CarouselContent, CarouselItem } from "@repo/ui/carousel";
import { JourneyCard, type JourneyCardData } from "@/components/templates/journey/journey-card.component";
interface JourneyRailCarouselProps {
  journeys: JourneyCardData[];
  locale: string;
}
const itemClass = "basis-[min(380px,85vw)] pl-3 tablet:pl-6";

// A handful of journeys fit the viewport — center them as a static row rather
// than left-aligning a barely-scrolling carousel. Above this, use the carousel.
const CENTER_THRESHOLD = 4;
export function JourneyRailCarousel(t0) {
  const $ = _c(15);
  const {
    journeys,
    locale
  } = t0;
  if (journeys.length <= CENTER_THRESHOLD) {
    let t1;
    if ($[0] !== journeys || $[1] !== locale) {
      let t2;
      if ($[3] !== locale) {
        t2 = (journey, index) => <div key={journey._id} className="shrink-0 grow-0 basis-[min(380px,85vw)]"><JourneyCard journey={journey} locale={locale} shapeIndex={index} /></div>;
        $[3] = locale;
        $[4] = t2;
      } else {
        t2 = $[4];
      }
      t1 = journeys.map(t2);
      $[0] = journeys;
      $[1] = locale;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[5] !== t1) {
      t2 = <div data-testid="journey-rail-carousel" className="flex flex-wrap justify-center gap-3 px-4 tablet:gap-6 desktop:px-16">{t1}</div>;
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t1;
  if ($[7] !== journeys || $[8] !== locale) {
    let t2;
    if ($[10] !== locale) {
      t2 = (journey_0, index_0) => <CarouselItem key={journey_0._id} className={itemClass}><JourneyCard journey={journey_0} locale={locale} shapeIndex={index_0} /></CarouselItem>;
      $[10] = locale;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    t1 = journeys.map(t2);
    $[7] = journeys;
    $[8] = locale;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden={true} className="shrink-0 grow-0 basis-4 desktop:basis-16" />;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t1) {
    t3 = <Carousel align="start" duration={40} dragFree={true} wheelGestures={true} aria-label="Journey rail" data-testid="journey-rail-carousel"><CarouselContent viewportClassName="pl-4 desktop:pl-16" className="-ml-3 tablet:-ml-6">{t1}{t2}</CarouselContent></Carousel>;
    $[13] = t1;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}